import { makeStyles, createStyles } from '@material-ui/styles';
import { Button, Typography, Theme } from '@material-ui/core';
import React, { FC } from 'react';

export interface PagingControlsProps {
  page: number;
  pageCount: number;
  onChangePage: (page: number) => void;
  pageOffsets: number[];
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    pagingControls: {
      display: "flex",
      alignContent: 'center',
      alignItems: 'center',
      height: '38px',
      justifyContent: "space-between",
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[1],
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
    pageTitle: {},
    buttonTitle: { height: '32px', textTransform: "none" },
  });
});

export const PagingControls: FC<PagingControlsProps> = function (props) {
  const { page, pageCount, onChangePage, pageOffsets } = props;
  const classes = useStyles(props);
  const canGoBack = page !== 0;
  const canGoForward = page !== pageCount - pageOffsets.length - 1;

  /**
   * Skip over pages that are not visible in the table of contents
   */
  function goBack() {
    const highestOffset = pageOffsets.find(offset => {
      return page - 1 === offset;
    })

    let targetPage;

    if (highestOffset) {
      targetPage =  page - 2;
    } else {
      targetPage = page - 1;
    }

    onChangePage(targetPage);
  }

  /**
   * Skip over pages that are not visible in the table of contents
   */
  function goForward() {
    const highestOffset = pageOffsets.find(offset => {
      return page + 1 === offset;
    })

    let targetPage;

    if (highestOffset) {
      targetPage =  page + 2;
    } else {
      targetPage = page + 1;
    }

    onChangePage(targetPage);
  }

  return (
    <div className = { classes.pagingControls }>
      <Button size={ "small" } className = { classes.buttonTitle} color = { 'primary' } disabled = { !canGoBack } variant = { 'contained' } onClick = { goBack }>
        Prev
      </Button>
      <Typography className = { classes.pageTitle } variant = { 'body1' }>
        Page { page + 1 } of { pageCount - pageOffsets.length }
      </Typography>
      <Button size={ "small" } className = { classes.buttonTitle } color = { 'primary' } disabled = { !canGoForward } variant = { 'contained' } onClick = { goForward }>
        Next
      </Button>
    </div>
  )
};
